/**
 * Small "document with folded corner" icon showing the file type (PDF, PPT,
 * XLS, DOCX...) as a label inside it — matches the approved reference
 * design for document lists across the Admin portal.
 */
export function DocumentTypeIcon({ type }: { type: string }) {
  const label = (type || "FILE").toUpperCase().slice(0, 4);
  return (
    <svg width="28" height="34" viewBox="0 0 28 34" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4 2H17L24 9V30C24 31.1046 23.1046 32 22 32H4C2.89543 32 2 31.1046 2 30V4C2 2.89543 2.89543 2 4 2Z"
        stroke="#2f5fdc"
        strokeWidth="1.6"
        fill="white"
      />
      <path d="M17 2V9H24" stroke="#2f5fdc" strokeWidth="1.6" strokeLinejoin="round" />
      <text
        x="13"
        y="23"
        textAnchor="middle"
        fontSize={label.length > 3 ? "6.5" : "7.5"}
        fontWeight="700"
        fill="#2f5fdc"
        fontFamily="Arial, sans-serif"
      >
        {label}
      </text>
    </svg>
  );
}
